import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import { Grid } from 'rewire-grid';
import { Theme } from '@material-ui/core/styles';
import responsesLogViewModel from './ResponsesLogViewModel';
import { withStyles } from '../utility/styles';

const styles = (_theme: Theme) => ({
  errorIcon: {
    color: _theme.palette.error.main,
  },
  warningIcon: {
    color: '#cc8100',
  },
  root: {
    '& tr.matches.error': {
      fontStyle: 'italic',
      color: _theme.palette.error.main,
    },
    '& tr.matches.warning': {
      fontStyle: 'italic',
      color: '#cc8100',
    },
  },
});

interface IInfoPanelShiftResponseLogViewProps {}

type InfoPanelShiftResponseLogViewProps = WithStyle<ReturnType<typeof styles>, IInfoPanelShiftResponseLogViewProps>;

class InfoPanelShiftResponseLogView extends React.PureComponent<InfoPanelShiftResponseLogViewProps> {
  constructor(props: InfoPanelShiftResponseLogViewProps) {
    super(props);
  }

  renderResponseLog = React.memo((): JSX.Element => {
    const gridFontSizes = {
      header: '0.75em',
      body: '0.75em',
      groupRow: '1em',
      toggleMenu: '0.8em',
    };

    const gridColors = {
      // cellSelectedBackground: '#D0DEE8',
      // cellOutline: 'none',
    };

    return (
      <Observe
        render={() =>
          (responsesLogViewModel.grid?.id && (
            <Grid
              key={responsesLogViewModel.grid.id}
              grid={responsesLogViewModel.grid}
              gridFontSizes={gridFontSizes}
              gridColors={gridColors}
            />
          )) ||
          null
        }
      />
    );
  });

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <this.renderResponseLog />
      </div>
    );
  }
}

export default withStyles<IInfoPanelShiftResponseLogViewProps>(styles, InfoPanelShiftResponseLogView);
